<template>
  <div class="form-group">
    <label for="children" class="h6 text-left font-weight-bold text-white text-uppercase mt-0 mb-0 w-100">Djeca</label>
    <input type="number" id="children" class="form-control" v-model.number="totalChildren" min="0" max="4"
           @input="handleChildren" />
    <h6 class="h7 text-left text-white mt-3 mb-2 w-100" v-if="totalChildren > 0">
      Godine djeteta pri povratku s putovanja:
    </h6>
    <div v-for="i in totalChildren" :key="`child-age-index-${i}`" class="d-flex" :class="{ 'mt-1': i > 1 }">
      <label v-html="`${i}. dijete:`" class="h6 text-left text-white mt-2 mb-0 pl-4 w-100"></label>
      <select class="form-control form-control-sm ml-auto" v-model="childrenAgesLocal[i-1]" >
        <option v-for="k in 17" :key="k" :value="k" v-html="k"></option>
      </select>
      <input type="hidden" name="childAges" :value="getChildrenAgesAsString" />
    </div>
  </div>

</template>

<script>
export default {
  props: {
    childrenAges: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      childrenAgesLocal: this.childrenAges,
      totalChildren: this.childrenAges.length
    };
  },

  computed: {
    getChildrenAgesAsString() {
      return this.childrenAgesLocal.join();
    }
  },

  watch: {
    totalChildren(val) {
      if (val == 0) {
        this.childrenAgesLocal = [];
      } else if (this.childrenAgesLocal.length > val) {
        return this.childrenAgesLocal.splice(
          val,
          this.childrenAgesLocal.length
        );
      }
    }
  },

  methods: {
    handleChildren() {
      if (this.totalChildren > 4) {
        this.totalChildren = 4;
      } else if (this.totalChildren < 0) {
        this.totalChildren = 0;
      }
    }
  }
};
</script>
